import React, { useState, useEffect } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Button, Modal } from "react-bootstrap";
import OrderConfirmation from "./OrderConfirmation";
import { useNavigate } from "react-router-dom";
import AddressList from "./AddressList";
import PWAHeader from '../common/PWAHeader';
import PrimaryButton from '../common/PrimaryButton';
import { apply_discount, fetch_cart_v2, fetch_razorpay_orderid, fetch_razorpay_transaction_status_v2, initiate_partial_cart_payment_uht, updateCartV2 } from '../apiservices/ApiService';

const ShoppingCartPage = () => {
  const [modalMessage, setModalMessage] = useState(""); // For showing messages in a modal
  const [showModal, setShowModal] = useState(false); // Modal visibility
  const [cartData, setCartData] = useState(null); // Cart Data
  const [showOrderConfirmation, setShowOrderConfirmation] = useState(false); // Order Confirmation
  const [orderData, setOrderData] = useState({}); // Order Confirmation

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);


  const [address, setAddress] = useState(null);

  const [showPriceDetails, setShowPriceDetails] = useState(true);
  const [couponCode, setCouponCode] = useState('');

  const [cartItems, setCartItems] = useState(null);
  const [showAddressList, setShowAddressList] = useState(false);
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [goqiiCashApplied, setGoqiiCashApplied] = useState(true);
  const [couponCodeSelected, setCouponCodeSelected] = useState(false);

  const goBack = () => {
    navigate(-1);  // This will navigate to the previous page
  };

  const showAddressSelection = (addAddress) => {
    setShowAddressList(true);
    setShowAddAddress(addAddress);
  };

  const hideAddressSelection = () => {
    setShowAddressList(false);
    setShowAddAddress(false);
  }

  const handleAddressSelect = (address) => {
    if (address != null) {
      console.log("Selected Address:", address);
      setAddress(address);
    }
    hideAddressSelection();
  };




  const loadVideoComponents = async () => {

    console.error("fetch_cart_v2 : ");
    const response = await fetch_cart_v2({});

    console.error("fetch_cart_v2 : ", response);

    if (response.code === 200 && response.data != null) {

      if (response.data.cart != null && response.data.cart.length > 0)
        setCartItems(response.data.cart[0].available);
      else
        setCartItems([]);
      setAddress(
        response.data.address ? response.data.address[0] : null
      );
      setCartData(response.data)

    }
  };

  useEffect(() => {
    loadVideoComponents();


  }, []);

  const updateCart = async (id, increment, quantity) => {
    setLoading(true);
    var productsJson = [{ productId: id, quantity: increment ? parseInt(quantity) + 1 : parseInt(quantity) - 1 }]








    const response = await updateCartV2({ productsJson: JSON.stringify(productsJson), flow: "cart" });
    if (response.code === 200 && response.data != null) {
      if (response.data.cart != null && response.data.cart.length > 0)
        setCartItems(response.data.cart[0].available);
      else
        setCartItems([]);
      setCartData(response.data)
    }
    setLoading(false)

  };

  const storeHomeNavigation = () => {
    const currentQueryParams = window.location.search;
    window.location.href = `/store_home_page${currentQueryParams}`
  };

  const fetchRazorpayOrderId = async (orderId) => {


    const response = await fetch_razorpay_orderid({ orderId: orderId });

    if (response.code === 200 && response.data != null) {

      handlePayment(response.data.razorpay, orderId);
    }
    setLoading(false);

  };


  const fetchRazorpayOrderStatus = async (orderId) => {
    const response = await fetch_razorpay_transaction_status_v2({ orderId: orderId });
    if (response.code === 200 && response.data != null) {
      setOrderData(response.data);
      setShowOrderConfirmation(true);
    }
  };

  const applyDiscount = async (goqiiCashApplied, couponCode) => {
    console.log("goqiiCashApplied:", goqiiCashApplied, "couponCode:", couponCode);
    setGoqiiCashApplied(goqiiCashApplied);
    if (couponCode != "" || couponCode === "-") {
      setCouponCodeSelected(true);
    } else {
      setCouponCodeSelected(false);
    }
    setLoading(true);
    const productsList = cartItems.map((item) => ({
      quantity: item.quantityOrdered,
      productId: item.productId,
    }));


    const response = await apply_discount({

      cartId: cartData.cartId,
      goqiiCash: goqiiCashApplied ? "Y" : "N",
      coupon: couponCode === "-" ? "" : couponCode,
      storeCredit: "N",
      uhtTokenApply: "N",
      selectedProducts: JSON.stringify(productsList),
    });

    if (response.code === 200 && response.data != null) {
      setCartData({ ...cartData, subTotal: response.data.subTotal, cashDiscount: response.data.cashDiscount, deliveryCharges: response.data.deliveryCharges, grandTotal: response.data.grandTotal });
      console.log("Discount Applied", JSON.stringify(response.data))
    } else if (response.data != null && response.data.message) {
      alert(response.data.message);
    } else {
      alert("Something went wrong. Please try again later");
    }
    setLoading(false);

  };

  const initiatePartialCartCheckout = async () => {
    setLoading(true);
    const productsList = cartItems.map((item) => ({
      quantity: item.quantityOrdered,
      productId: item.productId,
    }));
    try {


      const response = await initiate_partial_cart_payment_uht({
        
        addressId: cartData.address.addressId,
        productsJson: JSON.stringify(productsList),
        name: address.name,
        cartTotal: cartData.cartTotal,
        deliveryCharges: cartData.deliveryCharges,
        subTotal: cartData.subTotal,
        grandTotal: cartData.grandTotal,
        cashDiscount: cartData.cashDiscount,
        userEmail: address.email,
        userPhoneNumber: address.mobile,
        address: address.address,
        city: address.city,
        state: address.state,
        pinCode: address.pinCode,
        landmark: address.landmark,
        storeCredit: 'N',
        uhtTokenApply: 'N',
        paymentvia: 'razorpay'
      });


      if (response.code === 200 && response.data != null) {
        if (response.data.rt === "1") {
          console.log("Order id created")
          fetchRazorpayOrderId(response.data.orderId)
        } else {
          console.log("Order success without payment.")
        }
        setLoading(false);
      } else if (response.data != null && response.data.message) {
        alert(response.data.message);
        setLoading(false);
      }

    } catch (err) {
      console.log("Failed to fetch addresses: ")
    } finally {
      setLoading(false);
    }
  };


  const calculateTotals = () => {
    return {
      subtotal: cartData.subTotal,
      cashDiscount: cartData.cashDiscount,
      deliveryCharges: cartData.deliveryCharges,
      total: cartData.grandTotal,
    };
  };

  const handlePayment = async (orderData, goqiiOrderId) => {
    try {

      var order_id = orderData.order_id;
      var amount = orderData.amount;
      var name = orderData.name;
      var contact = orderData.contact;
      var email = orderData.email;
      var description = orderData.description;
      var currency = orderData.currency;

      const options = {
        key: process.env.REACT_RAZORPAY_KEY,
        amount: amount,
        currency: currency,
        name: "GOQII",
        description: description,
        order_id: order_id,
        handler: function (response) {
          fetchRazorpayOrderStatus(goqiiOrderId)
        },
        prefill: {
          name: name,
          email: email,
          contact: contact,
        },
        theme: {
          color: "#F37254",
        },
        method: {
          card: false, // Show card payment method
          netbanking: false, // Show net banking payment method
          wallet: false, // Hide wallet payment method
          upi: true, // Show UPI payment method
          paylater: false,
          emi: false
        }
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Error in payment:", error);
    }
  };

  if (cartItems === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "1.5rem", // Optional: Increase font size for better visibility
        }}
      >
        Loading...
      </div>
    );
  }
  if (cartItems === undefined || cartItems.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#f9fafb",
          color: "#333",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <img
          src="https://appcdn.goqii.com/storeimg/5191_1733314155.gif"
          alt="Empty Cart"
          style={{ maxWidth: "100px", marginBottom: "20px" }}
        />
        <h2
          style={{
            fontSize: "24px",
            marginBottom: "10px",
            fontWeight: "600",
            color: "#555",
          }}
        >
          Your Cart is Empty
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#777",
            marginBottom: "20px",
          }}
        >
          Looks like you haven’t added anything to your cart yet.
        </p>
        <button
          onClick={() => storeHomeNavigation()} // Replace with actual navigation logic
          style={{
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            color: "white",
            fontSize: "16px",
            border: "none",
            borderRadius: "20px",
            cursor: "pointer",
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          Start Shopping
        </button>
      </div>

    );
  }

  if (showOrderConfirmation) {
    return (<OrderConfirmation orderData={orderData} />);
  }

  const priceBreakdown = calculateTotals();

  if (showAddressList) {
    return (
      <AddressList
        onAddressSelect={handleAddressSelect}
        defaultShowAddAddress={showAddAddress}
        onCancel={() => hideAddressSelection()}
      />
    );
  }

  return (
    <div
      style={{ maxWidth: "42rem", margin: "0 auto", display: "flex", flexDirection: "column", minHeight: "100vh", background: "rgba(255, 152, 0, 0.11)", }}
    >
      {/* Header */}
      {/* <header
        style={{
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          position: "sticky",
          top: 0,
          zIndex: 10
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0.75rem 1rem",
          }}
        > */}
      {/* <ChevronLeft onClick={goBack} style={{ width: '24px', height: '24px' }} /> */}
      {/* <img src="https://appcdn.goqii.com/storeimg/79908_1733642827.webp" onClick={goBack} style={{ objectFit: 'contain', width: '24px', height: '24px' }} /> */}
      {/* <div
            style={{
              fontSize: '18px',
              fontWeight: '400',
              display: "flex",
              gap: "1rem",
              marginLeft: "10px",
            }}
          >
            Checkout
          </div> */}


      {/* </div>
      </header> */}
      <PWAHeader title="Checkout" onBack={goBack} />

      {/* Delivery Address */}
      <div
        style={{
          padding: '1rem',
          // background: 'rgba(255, 152, 0, 0.11)',
          marginTop: '0.5rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
          }}
        >
          <div style={{ fontSize: '1rem', fontWeight: '500', color: '#681517' }}>
            DELIVERY ADDRESS
          </div>
          <button
            style={{
              background: '#681517',
              borderRadius: '999px',
              padding: '0px 5px 5px 5px',
              color: '#fff',
              border: 'none',
            }}
          >
            <Plus onClick={() => showAddressSelection(address ? false : true)} style={{ width: '20px', height: '20px' }} />
          </button>
        </div>
        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            gap: '1rem',
          }}
        >
          <div style={{ flexShrink: 0 }}>
            <div
              style={{
                width: '64px',
                height: '64px',
                border: '1px solid #681517',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(90deg, #fff 0%, rgba(255, 152, 0, 0.11) 70%)',
              }}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/56418_1732799645.png"
                alt="Delivery Address"
                style={{ width: '40px', height: '40px' }}
              />
            </div>
          </div>
          <div>
            <div style={{ color: '#333' }}>{address?.name}</div>
            <div
              style={{
                color: '#681517',
                fontSize: '0.875rem',
                fontWeight: '600',
                marginTop: '0.25rem',
              }}
            >
              {address?.address + ", " + address?.landmark + ", " + address?.city + ", " + address?.state + ", " + address?.pinCode}
            </div>
            <div
              style={{
                color: '#681517',
                fontSize: '0.875rem',
                marginTop: '0.25rem',
              }}
            >
              {address?.mobile}
            </div>
          </div>
        </div>
      </div>

      {/* Cart Items */}
      <div
        style={{
          marginTop: '0.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
        }}
      >
        {cartItems.map((item, index) => (
          <div
            key={item.productId}
            style={{
              background: "linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)",
              // background: index % 2 === 0 ? 'linear-gradient(to left, #fff 0%, rgba(255, 152, 0, 0.2) 100%)' : 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.2) 100%)',
              padding: '1rem',
              borderBottom: '1px solid #ddd',
            }}
          >
            <div style={{ display: 'flex', gap: '1rem' }}>
              <img
                src={item.productImageUrl[0]}
                alt={item.productTitle}
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#681517' }}>{item.productTitle}</h3>
                <div
                  style={{
                    marginTop: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#681517',
                      color: '#fff',
                      borderRadius: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    <button
                      onClick={() => updateCart(item.productId, false, item.quantityOrdered)}
                      style={{
                        padding: '0.5rem',
                        cursor: 'pointer',
                        border: 'none',
                        background: 'transparent',
                        color: '#fff',
                        marginBottom: '4px',
                      }}
                    >
                      <Minus style={{ width: '16px', height: '16px' }} />
                    </button>
                    <span style={{ padding: '0.5rem', fontWeight: '500' }}>
                      {item.quantityOrdered}
                    </span>
                    <button
                      onClick={() => updateCart(item.productId, true, item.quantityOrdered)}
                      style={{
                        padding: '0.5rem',
                        cursor: 'pointer',
                        border: 'none',
                        background: 'transparent',
                        color: '#fff',
                        marginBottom: '4px',
                      }}
                    >
                      <Plus style={{ width: '16px', height: '16px' }} />
                    </button>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: '0.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                >
                  <span style={{ textDecoration: 'line-through', color: '#aaa' }}>
                    ₹{item.actualPrice * item.quantityOrdered}
                  </span>
                  <span style={{ color: '#681517', fontWeight: '600' }}>
                    ₹{item.finalPrice * item.quantityOrdered}
                  </span>
                </div>
                {
                  item.perItemDiscount && item.perItemDiscount != "0" ?
                    <div style={{ color: '#666' }}>
                      - GOQii Cash Reward: ₹{item.perItemDiscount ? item.perItemDiscount * item.quantityOrdered : 0}
                    </div>
                    : ""
                }
                <div style={{ color: '#666' }}>
                  + Delivery Charges: ₹{item.deliveryCharges.number}
                </div>
                {item.uhtRewards && (
                  <div
                    style={{
                      background: '#e6f9e6',
                      color: '#681517',
                      padding: '0.25rem 0.5rem',
                      borderRadius: '999px',
                      marginTop: '0.5rem',
                      display: 'inline-block',
                    }}
                  >
                    UHT Rewards: {item.uhtRewards}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Apply Offer */}
      <div
        style={{
          padding: '1rem',
          // background: 'linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.5) 100%)',
          marginTop: '0.5rem',
        }}
      >
        <h3 style={{ fontWeight: '500', marginBottom: '1rem', color: '#681517' }}>APPLY OFFER</h3>
        <div>
          <div
            style={{
              border: '1px solid #681517',
              background: 'linear-gradient(to top, #fff 0%, rgba(255, 152, 0, 0.2) 100%)',
              borderRadius: '8px',
              padding: '10px',
              marginBottom: '1rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <input type="radio" id='radioGoqiiCash' checked={goqiiCashApplied} onClick={() => applyDiscount(true, "")} style={{ width: '16px', height: '16px', accentColor: '#681517', border: '1px solid #681517' }} />
            <div style={{ marginLeft: '0.75rem' }}>
              <div style={{ color: '#681517', fontWeight: '600' }}>
                ₹{cartData.cashDiscount} OFF
              </div>
              <div style={{ color: '#666', fontSize: '0.875rem' }}>
                GOQii Cash Reward
              </div>
            </div>
          </div>
          <div
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '10px', display: 'none'
            }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input type="radio" checked={couponCodeSelected} id='radioCoupon' style={{ width: '16px', height: '16px' }} onClick={() => applyDiscount(false, "-")} />
              <div style={{ marginLeft: '0.75rem' }}>
                <div style={{ color: '#007bff', fontWeight: '500' }}>COUPON</div>
                <div style={{ color: '#666', fontSize: '0.875rem' }}>
                  Apply GOQii Coupon Code
                </div>
                <div style={{ color: '#681517', marginTop: '5px', fontSize: '0.875rem' }}>
                  <input
                    type="text"
                    placeholder="Enter Code"
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: '0.5rem',
                      width: '180px',
                      height: '38px'
                    }}
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  {/* <Button style={{ marginLeft: '10px', height: '38px' }} variant='outline-primary' 
                  onClick={() => { couponCode ? applyDiscount(false, couponCode) : alert("Enter Coupon Code", 500) }}>Apply</Button> */}
                  <PrimaryButton
                    style={{ marginLeft: '10px', height: '38px' }}
                    label={"Apply"}
                    onClick={() => { couponCode ? applyDiscount(false, couponCode) : alert("Enter Coupon Code", 500) }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Price Details */}
      <div
        style={{
          // padding: '1rem',
          background: 'rgba(255, 152, 0, 0.11)',
          marginTop: '0.5rem',
          borderTop: '1px solid #ddd',
        }}
      >
        <div
          onClick={() => setShowPriceDetails(!showPriceDetails)}
          style={{
            padding: '1rem',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: '#fff',
            background: 'linear-gradient(to right, #681517 0%, #FF9800 100%)',
            transition: 'all 0.3s',
          }}
        >
          <span style={{ fontWeight: '600' }}>PRICE DETAILS</span>
          <span style={{ color: '#fff', fontWeight: '700' }}>
            {showPriceDetails ? 'Hide' : 'Show'}
          </span>
        </div>
        {showPriceDetails && (
          <div style={{ marginTop: '1rem', color: '#681517', padding: '1rem', transition: 'all 0.3s' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Subtotal</span>
              <span>₹{priceBreakdown.subtotal}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>GOQii Cash Reward</span>
              <span>- ₹{priceBreakdown.cashDiscount}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>Delivery Charges</span>
              <span>₹{priceBreakdown.deliveryCharges}</span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: '500',
              }}
            >
              <span>Total</span>
              <span>₹{priceBreakdown.total}</span>
            </div>
          </div>
        )}
      </div>

      {/* Fixed Bottom Bar */}
      <div style={{
        position: 'sticky',
        bottom: '0',
        left: '0',
        right: '0',
        background: 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0) 100%)',
        borderTop: '1px solid #ddd',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }} onClick={() => { address ? initiatePartialCartCheckout() : showAddressSelection(true) }}>
        <span style={{ textAlign: 'center', width: '50%', color: '#681517', fontWeight: '700', fontSize: '18px' }}>
          ₹{priceBreakdown.total}
        </span>
        <div
          style={{
            textAlign: 'center',
            width: '50%',
            fontSize: '18px',
            background: 'linear-gradient(90deg, #681517 0%, #FF9800 100%)',
            color: '#fff',
            padding: '0.75rem 1.5rem',
            fontWeight: '500',
          }}>{address ? "Proceed to Pay" : "Add Address"}
        </div>

      </div>

      {
        loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column', // Align items vertically
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  border: "4px solid #f3f3f3",
                  borderRadius: "50%",
                  borderTop: "4px solid #4CAF50",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
              <div
                style={{
                  textAlign: 'center',
                  color: 'white',
                  fontWeight: "400",
                  marginTop: '0.2rem', // Space between spinner and text
                }}
              >
                Please wait...
              </div>
            </div>

            <style>
              {`
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}
            </style>
          </div>

        )
      }

      {/* Modal to show error messages */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Payment Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default ShoppingCartPage;